import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { Injector, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from '@core/core.module';
import { MaterialModule } from '@material';
import { PipeModule } from '@pipes/pipes.module';
import { WINDOW_PROVIDERS } from '@services';
import { CopyClipboardModule } from '@shared/modules/copy-clipboard/copy-clipboard.module';
import { PhoneInputModule } from '@shared/modules/phone-input/phone-input.module';
import { SharedModule } from '@shared/shared.module';
import { OAuthModule } from 'angular-oauth2-oidc';
import { ToastrModule } from 'ngx-toastr';
import { Ng2Webstorage } from 'ngx-webstorage';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CustomPreloadingStrategy } from './preload.strategy';
import { ApiHelper } from './services/api-helper';
import { FirebaseModule } from './services/firebase';
import { FirebaseAuthService } from './services/firebase/firebase-auth.service';
import { AWISLinkInterceptor, JWTErrorInterceptor, JWTInterceptor } from './services/interceptors';

const allowedUrls = [
  'http://webclient.web-dev.sb.np.ua/data/get/container/json',
];

export let AppInjector: Injector;

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserAnimationsModule,
    PipeModule,
    PhoneInputModule,
    FirebaseModule.forRoot(),
    ToastrModule.forRoot({ newestOnTop: false }),
    Ng2Webstorage.forRoot(),
    OAuthModule.forRoot({
      resourceServer: { allowedUrls, sendAccessToken: true },
    }),
    CoreModule,
    SharedModule,
    CopyClipboardModule,
  ],
  providers: [
    FirebaseAuthService,
    WINDOW_PROVIDERS,
    ApiHelper,
    { provide: HTTP_INTERCEPTORS, useClass: JWTInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AWISLinkInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JWTErrorInterceptor, multi: true },
    CustomPreloadingStrategy,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private injector: Injector) {
    AppInjector = this.injector;
  }
}
